import { render, staticRenderFns } from "./global-notification.vue?vue&type=template&id=7fc4056e&"
import script from "./global-notification.vue?vue&type=script&lang=js&"
export * from "./global-notification.vue?vue&type=script&lang=js&"
import style0 from "./global-notification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports